import { z } from 'zod';

export const RecoQuerySchema = z.object({
  token: z.string(),
});

export const RecommendationResponseSchema = z.object({
  clientName: z.string(),
  platformName: z.string(),
  recommendation: z.object({
    status: z.enum([
      'ACTIVE',
      'ACCEPTING',
      'REJECTED',
      'ACCEPTED',
      'ERROR',
      'EXPIRED',
    ]),
    taxonomy: z.object({
      channel: z.object({
        platform: z.object({
          name: z.string(),
          status: z.union([
            z.object({
              data: z.array(
                z.object({
                  objectId: z
                    .union([z.string(), z.number(), z.null()])
                    .optional(),
                  objectType: z.union([z.string(), z.null()]).optional(),
                  status: z.enum(['success', 'pending', 'error']).optional(),
                  details: z.union([z.string(), z.null()]).optional(),
                }),
              ),
            }),
            z.null(),
          ]),
        }),
      }),
    }),
    journeyName: z.string().optional(),
  }),
});

export const ProveActionRequestSchema = z.object({
  action: z.string(),
});
